import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {IRegistry} from "../../../../../../../utils/interfaces/my_documents/fiscal_registry/IRegistry";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiGetRegistry = (fiscal_registry_id: number | undefined, pk: number | undefined
): UseQueryResult<IRegistry, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined, fiscal_registry_id: number | undefined, pk: number | undefined): Promise<IRegistry> {
        try {
            const response = await get(`/api/company/${company_token}/my_documents/fiscal_registry/${fiscal_registry_id}/registry/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetRegistry", pk],
        enabled: !!pk,
        queryFn: () => doGet(selectedCompany?.company_token, fiscal_registry_id, pk)
    })

};

export default useApiGetRegistry